// quick-add.js (COMPLET - FIX 404 section_id quickadd-* + SYNC PRIX)

if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this._abort = null;
        this._onChange = null;
      }

      hide(preventFocus = false) {
        const cartNotification =
          document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        this._teardown();
        if (this.modalContent) this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener?.setAttribute("aria-disabled", true);
        opener?.classList.add("loading");
        opener?.querySelector(".loading-overlay__spinner")?.classList.remove("hidden");

        const productUrl = opener?.getAttribute("data-product-url");
        if (!productUrl) {
          console.warn("[QuickAdd] data-product-url manquant");
          return this._unlock(opener);
        }

        fetch(productUrl)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, "text/html");

            // IMPORTANT : sur certains thèmes, la section peut être le root direct ou dans le DOM complet
            const main =
              doc.querySelector('section[id^="MainProduct-"]') ||
              doc.querySelector("#MainProduct") ||
              doc.querySelector("section");

            if (!main) {
              console.warn("[QuickAdd] MainProduct introuvable dans la réponse");
              return;
            }

            this.productElement = main;

            // ⚠️ On ne touche PAS aux data-section/data-url des pickers (sinon 404 Shopify)
            // On retire les éléments inutiles
            this._removeDOMElements();

            // Injecter
            this._setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this._removeGalleryListSemantic();
            this._preventVariantURLSwitching();

            // ✅ On branche notre sync prix (sans dépendre du fetch interne variant-radios)
            this._setupPriceSync(productUrl);

            super.show(opener);
          })
          .catch((e) => console.error("[QuickAdd] fetch error", e))
          .finally(() => this._unlock(opener));
      }

      _unlock(opener) {
        opener?.removeAttribute("aria-disabled");
        opener?.classList.remove("loading");
        opener?.querySelector(".loading-overlay__spinner")?.classList.add("hidden");
      }

      _setInnerHTML(element, html) {
        if (!element) return;
        element.innerHTML = html;

        // ré-injecter scripts inline
        element.querySelectorAll("script").forEach((oldTag) => {
          const s = document.createElement("script");
          Array.from(oldTag.attributes).forEach((a) => s.setAttribute(a.name, a.value));
          s.appendChild(document.createTextNode(oldTag.innerHTML));
          oldTag.parentNode.replaceChild(s, oldTag);
        });
      }

      _preventVariantURLSwitching() {
        if (!this.modalContent) return;
        const picker = this.modalContent.querySelector("variant-radios,variant-selects");
        if (!picker) return;
        picker.setAttribute("data-update-url", "false");
      }

      _removeDOMElements() {
        if (!this.productElement) return;
        this.productElement.querySelector("pickup-availability")?.remove();
        this.productElement.querySelector("product-modal")?.remove();
      }

      _removeGalleryListSemantic() {
        if (!this.modalContent) return;
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute("role", "presentation"));
      }

      _teardown() {
        if (this._abort) {
          this._abort.abort();
          this._abort = null;
        }
        if (this._onChange && this.modalContent) {
          const picker = this.modalContent.querySelector("variant-radios,variant-selects");
          picker?.removeEventListener("change", this._onChange, true);
        }
        this._onChange = null;
      }

      _setupPriceSync(productUrl) {
        this._teardown();
        if (!this.modalContent) return;

        const picker = this.modalContent.querySelector("variant-radios,variant-selects");
        if (!picker) {
          console.warn("[QuickAdd] Pas de variant-radios/selects dans le modal");
          return;
        }

        // ✅ Sélecteurs “prix” plus larges (car ton markup a été custom)
        const findPriceNode = (root) => {
          if (!root) return null;
          return (
            root.querySelector('[id^="price-"]') ||
            root.querySelector(".price") ||
            root.querySelector(".price__container") ||
            root.querySelector("[data-price]") ||
            root.querySelector('[role="status"][id*="price"]')
          );
        };

        const controller = new AbortController();
        this._abort = controller;

        const onChange = async () => {
          try {
            const idInput = this.modalContent.querySelector(
              'form[action^="/cart/add"] input[name="id"]'
            );
            const variantId = idInput?.value;
            if (!variantId) return;

            // ✅ IMPORTANT : on fetch la page produit SANS section_id=quickadd-...
            const base = productUrl.split("?")[0];
            const url = `${base}?variant=${encodeURIComponent(variantId)}`;

            const res = await fetch(url, { signal: controller.signal });
            if (!res.ok) {
              console.warn("[QuickAdd] fetch prix failed", res.status, url);
              return;
            }

            const html = await res.text();
            const doc = new DOMParser().parseFromString(html, "text/html");

            // On récupère le bloc prix dans le HTML “fresh”
            const freshMain =
              doc.querySelector('section[id^="MainProduct-"]') ||
              doc.querySelector("section");

            const freshPrice = findPriceNode(freshMain || doc);
            const modalPrice = findPriceNode(this.modalContent);

            if (!freshPrice || !modalPrice) {
              console.warn("[QuickAdd] prix introuvable (fresh ou modal)", {
                hasFresh: !!freshPrice,
                hasModal: !!modalPrice,
                url,
              });
              return;
            }

            modalPrice.innerHTML = freshPrice.innerHTML;
          } catch (e) {
            if (e?.name === "AbortError") return;
            console.error("[QuickAdd] erreur update prix", e);
          }
        };

        this._onChange = onChange;
        picker.addEventListener("change", onChange, true);

        // sync initial
        onChange();
      }
    }
  );
}
